// generated from 17 samples

import { z } from "zod";
import { filterGetBaseSchema } from "./filterGetBaseSchema";

export const hasConnectedFacebookFilterGetSchema = z.object({
  ...filterGetBaseSchema.shape,
  filter_key: z.literal("has_connected_facebook_filter"),
  comparison_key: z.literal("1"),
  display_name: z.string(),
  // undefined: 7 (41.18%), defined 10 (58.82%)
  // true 9 (90.00%), false 1 (10.00%)
  raw_value: z.boolean().optional(),
  // true 14 (82.35%), false 3 (17.65%)
  value: z.boolean(),
  varies_by_app_group: z.literal(false),
});
